import React from "react";
import PropTypes from "prop-types";
import { DatePicker } from "antd";
import dayjs, { Dayjs } from "dayjs";

interface CustomDatePickerProps {
    allowClear?: boolean;
    className?: string;
    cellRender?: (current: Dayjs, info: { from?: Dayjs }) => React.ReactNode;
    disabled?: boolean;
    disabledDate?: (current: Dayjs) => boolean;
    format?: string;
    minDate?: Dayjs | null;
    maxDate?: Dayjs | null;
    picker?: "date" | "week" | "month" | "quarter" | "year";
    placeholder?: string;
    size?: "large" | "middle" | "small";
    multiple?: boolean;
    showTime?: boolean;
    value?: Dayjs | Dayjs[] | null;
    onChange?: (date: Dayjs | Dayjs[] | null) => void;
    error?: string;
}

const CustomDatePicker: React.FC<CustomDatePickerProps> = ({
    allowClear = true,
    className = "",
    cellRender,
    disabled = false,
    disabledDate = () => false,
    format = "DD-MM-YYYY",
    minDate = null,
    maxDate = null,
    picker = "date",
    placeholder = "",
    size = "middle",
    multiple = false,
    showTime = false,
    value = null,
    onChange = () => {},
    error = "",
}) => {
    return (
        <>
            <DatePicker
                allowClear={allowClear}
                // className={`w-100 rounded-2 py-2 fs-6 ${className}`}
                className={`rounded-2 py-2 fs-6 w-full ${className}`}
                // cellRender={cellRender}
                disabled={disabled}
                disabledDate={disabledDate}
                // format={showTime ? false : format}
                minDate={minDate}
                maxDate={maxDate}
                picker={picker}
                placeholder={placeholder}
                size={size}
                multiple={multiple}
                // showTime={showTime ? { use12Hours: true, showTime } : false}
                value={value ? (Array.isArray(value) ? value.map(dayjs) : dayjs(value)) : null}
                onChange={disabled ? () => {} : onChange}
                status={error ? "error" : undefined}
            />
            {error && <span className="text-sm text-red-500">{error}</span>}
        </>
    );
};

CustomDatePicker.propTypes = {
    allowClear: PropTypes.bool,
    cellRender: PropTypes.func,
    disabledDate: PropTypes.func,
    format: PropTypes.string,
    minDate: PropTypes.any,
    maxDate: PropTypes.any,
    picker: PropTypes.oneOf(["date", "week", "month", "quarter", "year"]),
    placeholder: PropTypes.string,
    size: PropTypes.oneOf(["large", "middle", "small"]),
    multiple: PropTypes.bool,
    showTime: PropTypes.bool,
    value: PropTypes.any,
    className: PropTypes.string,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    error: PropTypes.string,
};

export default CustomDatePicker;
